import _ from "lodash";
import xml from "csi/xml";
import { C8Node, ICache } from "csi/typings";
import Processor from "./Processor";
import { Context } from "csi/def/Context";
import { IEvaluateParam } from "./ServerRollupScope";

/**
 *  rollup processor used to evaluate expressions
 */
let _rpEvaluate: Processor;
let _rpValidate: Processor;

/**
 * determine if expression contains the given id
 */
export function hasAttributeDependency(expr: string, id: string): boolean {
	if (_.isString(expr)) {
		const n = expr.indexOf(id);
		if (n > 0) {
			const c1 = expr.charAt(n - 1);
			const c2 = expr.charAt(n + id.length);

			return (c1 == c2) && ((c1 == "'") || (c1 == "\""));
		}
	}

	return false;
}

/**
 * evaluate the given expression
 */
export function evaluate(expr: string, node: C8Node, cache: ICache, bForQuery?: boolean, ctx?: Context, params?: IEvaluateParam): any {
	if (_rpEvaluate) {
		_rpEvaluate.reset(node, cache, ctx);
	} else {
		_rpEvaluate = new Processor(node, cache, ctx);
	}

	_rpEvaluate.setNowTime();

	try {
		let v = _rpEvaluate.evaluate(expr, null, null, params);

		// if evaluating an expression for a query filter, and the result is a client URL, then substitute with
		// source node URL, if any. This can happen when editing a node using a form, where a client node is 
		// used to store the latest changes to attributes on the form 
		if (bForQuery && _.isString(v) && xml.isClientUrl(v)) {
			const node = cache.get(v);
			const sourceUrl = node && node[xml.ATTR_CLIENT_SOURCE_URL];

			if (sourceUrl) {
				v = sourceUrl;
			} else {
				_rpEvaluate.toConsole(new Error("Query filter expression evaluates to client node URL."), expr);
			}
		}

		return v;
	} catch (ex) {
		// if there is a syntax error in an expression for a query, assume the given string was not an expression in the first place
		if (bForQuery && (ex instanceof SyntaxError)) {
			return expr;
		}

		_rpEvaluate.toConsole(ex, expr);
		return null;
	}
}

/**
 * validate the given value against the given boolean expression - if expression is not supported, return null
 */
export function validateValue(value: string, expr: string): any {
	_rpValidate = _rpValidate || new Processor();

	try {
		const v = _rpValidate.evaluate(expr, value);
		return v;
	} catch (ex) {
		_rpValidate.toConsole(ex, expr);
		return null;
	}
}